import { useEffect, useRef } from 'react';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { selectIsAuthenticated, setPermissions } from '@/store/slices/authSlice';

interface ClientPermissionsSyncProviderProps {
  children: React.ReactNode;
}

/**
 * Client Permissions Sync Provider
 *
 * Dispatches empty permissions, which sets `permissionsReady = true`.
 *
 * Access control is based on the Auth0 user `role` (Editor/Admin) from the
 * WebAPI, not on granular permission strings.
 */
export function ClientPermissionsSyncProvider({
  children,
}: ClientPermissionsSyncProviderProps) {
  const dispatch = useAppDispatch();
  const isAuthenticated = useAppSelector(selectIsAuthenticated);
  const hasSynced = useRef(false);

  useEffect(() => {
    if (isAuthenticated && !hasSynced.current) {
      dispatch(setPermissions([]));
      hasSynced.current = true;
    }

    if (!isAuthenticated) {
      hasSynced.current = false;
    }
  }, [isAuthenticated, dispatch]);

  return <>{children}</>;
}
